exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control-next[data-v-410b3f5a],.carousel-control-prev[data-v-410b3f5a]{filter:invert(100%)}", ""]);

// exports
